import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import ErrorModal from '../components/ErrorModal/ErrorModal';
import { State } from '../store/cases/types';
import { clearErrorModal } from '../store/cases/actions';

const state = (state: RootState) => {
  const currentCase = state.currentCase as State;
  return {
    error: currentCase.errorModal,
  };
};
const dispatchers = {
  onCloseButtonClick: clearErrorModal,
};

export default connect(state, dispatchers)(ErrorModal);
